import { render } from "./AposModalTabsBody.vue?vue&type=template&id=6ae3a15c&scoped=true"
import script from "./AposModalTabsBody.vue?vue&type=script&lang=js"
export * from "./AposModalTabsBody.vue?vue&type=script&lang=js"

import "./AposModalTabsBody.vue?vue&type=style&index=0&id=6ae3a15c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae3a15c"],['__file',"modal/ui/apos/components/AposModalTabsBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ae3a15c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ae3a15c', __exports__)) {
    api.reload('6ae3a15c', __exports__)
  }
  
  module.hot.accept("./AposModalTabsBody.vue?vue&type=template&id=6ae3a15c&scoped=true", () => {
    api.rerender('6ae3a15c', render)
  })

}


export default __exports__